import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/multi-conversation/history-and-pagination/history-and-pagination.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
